import React from 'react';

const StayContext = React.createContext({});

export const StayProvider = StayContext.Provider;
export const StayConsumer = StayContext.Consumer;

export default StayContext;
